import {
  Box,
  Heading,
  Link,
  ListItem,
  Stack,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import React from "react";
import { SiteData } from "../../Constants/siteData";

export const TreeRemovalContent = () => {
  return (
    <Box>
      <Stack spacing={3} py={5}>
        <Heading as={"h2"}>
          Expert Tree Removal Services for a Safe and Beautiful Property
        </Heading>
        <Text>
          At Overland Park Tree Care, we offer comprehensive tree removal
          services designed to enhance the safety and aesthetics of your
          property. Explore our range of offerings:
        </Text>
        <UnorderedList spacing={3}>
          <ListItem>
              <b>Dangerous Tree Removal:</b> Safely eliminate trees that pose a
              threat to your property or its surroundings, minimizing risks and
              ensuring overall safety. Our skilled arborists assess the situation 
              and employ advanced techniques to remove dangerous trees without 
              causing damage to surrounding structures.
          </ListItem>
          <ListItem>
              <b>Dead Tree Removal:</b> Efficiently remove unsightly and hazardous
              dead trees, preserving the health and beauty of your landscape. Our
              team carefully removes dead trees to prevent potential hazards and 
              improve the aesthetics of your property.
          </ListItem>
          <ListItem>
              <b>Diseased Tree Removal:</b> Identify and remove diseased trees to
              prevent the spread of illness to other plants, safeguarding the
              overall well-being of your green space. We use proper techniques 
              to safely remove diseased trees while minimizing the risk of 
              spreading disease to nearby trees.
          </ListItem>
          <ListItem>
              <b>Obstructive Tree Removal:</b> Clear the way for your construction
              or renovation projects by removing obstructive trees, providing a
              clean slate for your plans. Our team efficiently removes obstructive
              trees to make space for your projects while ensuring minimal 
              disruption to your property.
          </ListItem>
      </UnorderedList>

      </Stack>
  
      <Stack spacing={3} py={5}>
        <Heading as={"h2"}>
          Why Overland Park Tree Care for Your Tree Removal Needs?
        </Heading>
        <Text>
          With extensive local experience and a commitment to customer
          satisfaction, here's why Overland Park Tree Care stands out as your
          top choice:
        </Text>
        <UnorderedList spacing={3}>
          <ListItem>
              <b>Expert Arborists:</b> Our team of professional arborists
              possesses the skills and knowledge to perform tree removal safely
              and efficiently. With years of experience and ongoing training, 
              our arborists are equipped to handle trees of all sizes and 
              complexities.
          </ListItem>
          <ListItem>
              <b>Quality Service:</b> We prioritize delivering high-quality
              services, evident in our track record and positive customer reviews.
              From the initial assessment to the final cleanup, we ensure that 
              every aspect of our service meets the highest standards of quality 
              and professionalism.
          </ListItem>
          <ListItem>
              <b>Local Experts:</b> As specialists in local botany, shrubbery, and
              landscapes, we provide tailored services to meet the specific needs
              of your property. Our knowledge of local flora and fauna allows us 
              to recommend the best course of action for your trees and landscapes, 
              ensuring optimal health and vitality.
          </ListItem>
          <ListItem>
              <b>Customer Satisfaction:</b> Ensuring a smooth process is our top
              priority, aiming for complete customer satisfaction with every
              service. From the moment you contact us to the completion of the 
              project, we strive to exceed your expectations and ensure that 
              you are fully satisfied with the results.
          </ListItem>
      </UnorderedList>

      </Stack>

      <Stack spacing={3} py={5}>
        <Heading as={"h2"}>
          Premier Tree Removal Services in Overland Park, KS
        </Heading>
        <Text>
          Contact us today at{" "}
          <Link href={SiteData.telLink}>{SiteData.phoneNumberWithDashes}</Link>{" "}
          to schedule your tree removal service. Experience the Overland Park
          Tree Care difference!
        </Text>
      </Stack>
    </Box>
  );
};
